var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedSplitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5918 40.1837C31.4121 40.1837 40.1837 31.4121 40.1837 20.5918C40.1837 9.77156 31.4121 1 20.5918 1C9.77156 1 1 9.77156 1 20.5918C1 31.4121 9.77156 40.1837 20.5918 40.1837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41Z",
    fill: "#00609B",
    stroke: "#00609B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4151 22.8063V26.2492L18.8399 24.674L18.0127 25.5012L20.9977 28.4863L24.0144 25.5036L23.1918 24.6717L21.585 26.2604V22.8063H20.4151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0127 16.4848L18.8399 17.312L20.4151 15.7368V19.1797H21.585V15.7256L23.1918 17.3143L24.0144 16.4825L20.9977 13.4997L18.0127 16.4848Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7536 13.5058H15.2675C14.2999 13.5058 13.5127 14.293 13.5127 15.2606V26.7256C13.5127 27.6933 14.2999 28.4805 15.2675 28.4805H17.7536V27.3106H15.2675C14.945 27.3106 14.6826 27.0482 14.6826 26.7256V21.5781H27.3175V26.7256C27.3175 27.0482 27.0551 27.3106 26.7325 27.3106H24.2173V28.4805H26.7325C27.7002 28.4805 28.4874 27.6932 28.4874 26.7256V15.2606C28.4874 14.293 27.7001 13.5058 26.7325 13.5058H24.2173V14.6757H26.7325C27.0551 14.6757 27.3175 14.9381 27.3175 15.2606V20.4082H14.6826V15.2606C14.6826 14.9381 14.945 14.6757 15.2675 14.6757H17.7536V13.5058H17.7536Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedSplitIcon);
export default __webpack_public_path__ + "static/media/SelectedSplitIcon.ed276507baa7ee5620904d47da085168.svg";
export { ForwardRef as ReactComponent };